import {Component, Fragment} from 'react'
import renderRoutes from 'react-router-config/es/renderRoutes'
import {toastr} from 'react-redux-toastr'

import Navbar from '../../../../Navbar/Navbar.jsx'
import LeftMenu from '../../LeftMenu/LeftMenu.jsx'

import '../Profile.scss'
import api from '../../../../../../api.js'
import CardRow from "../../../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../../../shared/components/Styled/Card/CardCol.jsx"
import FreelancePageWrapper from "../../../../../../shared/components/Styled/Containers/FreelancePageWrapper.jsx"
import {X} from "react-feather"
import DefaultLayout from "../../../../Layout/DefaultLayout.jsx"
import CompleteProfileConfirmModal from "../../../../../../shared/components/Modals/CompleteProfileConfirmModal/CompleteProfileConfirmModal.jsx"
import {canOfferCompletion, getCompletionChecklist} from "../../../../../../shared/services/freelanceCompletionService.js"

export default class AdminProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hideMobileMenu: true,
      isCompleteProfileModalOpen: false,
      checkedCompletionForFreelanceId: null,
    }
  }

  componentDidMount() {
    this.scrollToHash()
    this.maybeOfferCompletion()
  }

  componentDidUpdate(prevProps) {
    setTimeout(() => {
      this.scrollToHash()
    }, 500)

    if (prevProps.profile?.freelance?.id !== this.props.profile?.freelance?.id) {
      this.maybeOfferCompletion()
    }
  }

  maybeOfferCompletion = () => {
    const {profile} = this.props
    const freelanceId = profile?.freelance?.id

    if (!freelanceId || this.state.checkedCompletionForFreelanceId === freelanceId) {
      return
    }

    this.setState({
      checkedCompletionForFreelanceId: freelanceId,
      isCompleteProfileModalOpen: canOfferCompletion(profile.user, profile.freelance),
    })
  }

  handleConfirmProfileCompletion = async () => {
    const {profile, refresh} = this.props
    const updatedUser = (await api.users.edit({
      user: profile.user.id,
      complete: true,
    })).data

    refresh({...profile, user: updatedUser})
    toastr.success(`Le profil de ${profile.user.fullname} est désormais complet`)
  }

  closeCompleteProfileModal = () => {
    this.setState({isCompleteProfileModalOpen: false})
  }

  scrollToHash = () => {
    const hash = window.location.hash
    if(!hash) {
      return
    }

    const elem = document.getElementById(hash.replace('#', ''))
    if(!elem) {
      return
    }
    elem.scrollIntoView({ behavior: "smooth", block: "start"})
  }

  renderProfilePage = () => {
    const {
      generate,
      currentUser,
      link,
      isOwner,
      onFormSuccess,
      profile,
      refresh,
      route,
      submit,
      submitUserFreelance,
    } = this.props

    return (
      <Fragment>
        <div className={`bg-gray-50 print-no-color ${this.props.className ? this.props.className : ''}`}
          onClick={(e) => {
            if (!this.state.hideMobileMenu){
              this.setState({hideMobileMenu: true})
            }
          }}
        >
          <CardRow gap="10px" className="container-fluid container-profile-freelance">
            <CardCol flex="flex: auto 0 250px" className="freelance-admin-profile">
              <div
                className={`level2-menu-mobile ${this.state.hideMobileMenu ? 'hide' : ''}`}
              >
                <CardRow justify='flex-end'><CardCol> <X/> </CardCol></CardRow>
                <LeftMenu
                  isMobile={true}
                  link={link}
                  freelance={profile?.freelance}
                  user={profile?.user}
                  refresh={refresh}
                />
              </div>

              <LeftMenu
                link={link}
                freelance={profile?.freelance}
                user={profile?.user}
                refresh={refresh}
              />
            </CardCol>
            <CardCol flex={1} className="">
              <FreelancePageWrapper
                onMobileCtaClick={() => {
                  this.setState({hideMobileMenu: false})
                }}>
                <div className="freelance-admin-profile freelance-profile">

                  {renderRoutes(route.routes, {
                    generate: generate,
                    edit: true,
                    user: profile?.user,
                    freelance: profile?.freelance,
                    link,
                    profile,
                    currentUser,
                    isAdmin: true,
                    isOwner,
                    submit,
                    submitUserFreelance,
                    refresh,
                    onFormSuccess,
                  })}
                </div>
              </FreelancePageWrapper>
            </CardCol>
          </CardRow>
        </div>
      </Fragment>
    )
  }
  render() {
    const {
      wrapWithLayout,
      profile,
    } = this.props
    const {
      renderProfilePage,
    } = this

    const completeProfileModal = (
      <CompleteProfileConfirmModal
        isOpen={this.state.isCompleteProfileModalOpen}
        freelanceFullName={profile?.user?.fullname}
        checklist={getCompletionChecklist(profile?.user, profile?.freelance)}
        onConfirm={this.handleConfirmProfileCompletion}
        onClose={this.closeCompleteProfileModal}
      />
    )

    if(wrapWithLayout) {
      return (<Fragment>
        <DefaultLayout>
          {renderProfilePage()}
        </DefaultLayout>
        {completeProfileModal}
      </Fragment>)
    }

    return (<Fragment>
      {this.props.navbar ? <Navbar locked={true} fixed={true} /> : ''}
      {renderProfilePage()}
      {completeProfileModal}
    </Fragment>)
  }
}
